import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { Filters } from '@apps/accommodations/hooks/useListingFilters';
import { checkboxOverrides, StyledCheckboxV2 } from '../../FiltersPanel/components';
import { SkeletonText } from '@shared/components/Skeleton';

export const CoupleRecommendationsCheck = ({ handlePickedByCoupleToggle, filters }: { handlePickedByCoupleToggle: () => void; filters: Filters }) => {
  const { t } = useTranslation('accommodationsConsole');
  const listingsTrans = t('listingsPanel');

  return (
    <Flex justifyContent="space-between" alignItems="center">
      <TextV2 typographyVariant={'hed4'}>{listingsTrans.title()}</TextV2>
      <StyledCheckboxV2 isChecked={filters.pickedByCouple} onChange={handlePickedByCoupleToggle} id={`couple-picks`} overrides={checkboxOverrides}>
        <TextV2 typographyVariant="body2" color="mono14">
          {listingsTrans.pickedByCouple()}
        </TextV2>
      </StyledCheckboxV2>
    </Flex>
  );
};

CoupleRecommendationsCheck.Skeleton = () => {
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <SkeletonText rows={1} width={136} skeletonHeight={26} />
      <SkeletonText rows={1} width={290} skeletonHeight={26} />
    </Flex>
  );
};
